import React from 'react';
import PropTypes from 'prop-types';

import AddedSugarsRow from 'components/shared/nutrition_facts/AddedSugarsRow';
import MainNutritionRow from 'components/shared/nutrition_facts/MainNutritionRow';
import { NUTRITION_ATTRIBUTES } from 'components/upb_viewer/pdp_components/ProductNutritionFactsView';
import SubNutritionRow from 'components/shared/nutrition_facts/SubNutritionRow';
import useFindAttributeValueByName from 'lib/hooks/product/useFindAttributeValueByName';

function CarbohydratesSection({ nutritionAttributes }) {
  const carbohydratesQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.CARBOHYDRATES_QUANTITYCONTAINED,
  );
  const carbohydratesUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.CARBOHYDRATES_UOM,
  );
  const carbohydratesDailyValue = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.CARBOHYDRATES_RDI_DAILYVALUEINTAKEPERCENT,
  );
  const carbohydratesPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.CARBOHYDRATES_MEASUREMENTPRECISIONCODE,
  );

  const totalDietFiberQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_DIETARY_FIBER_QUANTITYCONTAINED,
  );
  const totalDietFiberUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_DIETARY_FIBER_UOM,
  );
  const totalDietFiberDailyValue = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_DIETARY_FIBER_RDI_DAILYVALUEINTAKEPERCENT,
  );
  const totalDietFiberPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_DIETARY_FIBER_MEASUREMENTPRECISIONCODE,
  );

  const solubleFiberQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.SOLUBLE_FIBER_QUANTITYCONTAINED,
  );
  const solubleFiberUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.SOLUBLE_FIBER_UOM,
  );
  const solubleFiberPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.SOLUBLE_FIBER_MEASUREMENTPRECISIONCODE,
  );

  const insolubleFiberQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.INSOLUBLE_FIBER_QUANTITYCONTAINED,
  );
  const insolubleFiberUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.INSOLUBLE_FIBER_UOM,
  );
  const insolubleFiberPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.INSOLUBLE_FIBER_MEASUREMENTPRECISIONCODE,
  );

  const totalSugarQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_SUGAR_QUANTITYCONTAINED,
  );
  const totalSugarUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_SUGAR_UOM,
  );
  const totalSugarPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_SUGAR_MEASUREMENTPRECISIONCODE,
  );

  const addedSugarQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.ADDED_SUGAR_QUANTITYCONTAINED,
  );
  const addedSugarUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.ADDED_SUGAR_UOM,
  );
  const addedSugarDailyValue = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.ADDED_SUGAR_RDI_DAILYVALUEINTAKEPERCENT,
  );
  const addedSugarPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.ADDED_SUGAR_MEASUREMENTPRECISIONCODE,
  );

  if (!carbohydratesQuantity) {
    return null;
  }
  return (
    <>
      <MainNutritionRow
        title="Total Carbohydrates"
        quantity={carbohydratesQuantity}
        uom={carbohydratesUom}
        percentage={carbohydratesDailyValue}
        measurementPrecisionCode={carbohydratesPrecisionCode}
      />
      <SubNutritionRow
        title="Dietary Fiber"
        quantity={totalDietFiberQuantity}
        uom={totalDietFiberUom}
        percentage={totalDietFiberDailyValue}
        measurementPrecisionCode={totalDietFiberPrecisionCode}
        offset={1}
        boldPercentage
      />
      <SubNutritionRow
        title="Soluble Fiber"
        quantity={solubleFiberQuantity}
        uom={solubleFiberUom}
        measurementPrecisionCode={solubleFiberPrecisionCode}
        offset={2}
      />
      <SubNutritionRow
        title="Insoluble Fiber"
        quantity={insolubleFiberQuantity}
        uom={insolubleFiberUom}
        measurementPrecisionCode={insolubleFiberPrecisionCode}
        offset={2}
      />
      <SubNutritionRow
        title="Total Sugars"
        quantity={totalSugarQuantity}
        uom={totalSugarUom}
        measurementPrecisionCode={totalSugarPrecisionCode}
        offset={1}
        separatorOffset={addedSugarQuantity ? 2 : 0}
      />
      <AddedSugarsRow
        quantity={addedSugarQuantity}
        uom={addedSugarUom}
        percentage={addedSugarDailyValue}
        measurementPrecisionCode={addedSugarPrecisionCode}
      />
    </>
  );
}

CarbohydratesSection.propTypes = {
  nutritionAttributes: PropTypes.array,
};

export default CarbohydratesSection;
